import { useCallback } from 'react';
import { useRefresh } from 'react-admin';

export const useOnSettled = () => {
  const refresh = useRefresh();

  const onSettled = useCallback(() => {
    refresh();
  }, [refresh]);

  return {
    onSettled,
  };
};
